export const columnsDataOrgans = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Orgãos",
    accessor: "name",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "SIGFE",
    accessor: "sigfe",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  }
];

export const columnsDataEmployees = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "name",
  },
  {
    Header: "Categoria",
    accessor: "categoryId",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
];
export const columnsDataCategory = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Categoria",
    accessor: "name",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
];
export const columnsDataBeneficiary = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "name",
  },
  {
    Header: "Contribuinte",
    accessor: "contributor",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
];

export const columnsDataAccount = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Nome da conta",
    accessor: "accountName",
  },
  {
    Header: "Número de conta",
    accessor: "accountNumber",
  },
  {
    Header: "Moeda",
    accessor: "accountCurrency",
  },
  {
    Header: "Conta tipo",
    accessor: "accountType",
  },
  {
    Header: "Recebe emolmentos",
    accessor: "receiveFees",
  },
  {
    Header: "Número",
    accessor: "initialBalance",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  }
];

export const columnsDataNature = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "name",
  },
  {
    Header: "Categoria",
    accessor: "category",
  },
  {
    Header: "Código",
    accessor: "code",
  },
  {
    Header: "Tipo",
    accessor: "type",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  }
];

export const columnsDataContracts = [
  {
    Header: "#",
    accessor: "sNum",
  },
  {
    Header: "Beneficiário",
    accessor: "beneficiary",
  },
  {
    Header: "Afecto o",
    accessor: "affects",
  },
  {
    Header: "Descrição",
    accessor: "description",
  },
  {
    Header: "Tipo",
    accessor: "type",
  },
  {
    Header: "Valor Mensal",
    accessor: "amountValue",
  },
  {
    Header: "Moeda",
    accessor: "currency",
  },
  {
    Header: "Documento",
    accessor: "document",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  }
];
